// test532
(532 && 0);
